import {createStandardActions, GetActions, placeholder, readonly, standardItemsReducer} from "../../utils";
import {createStandardSelectors, getEntities, selector} from "../../selectors";
import {combineReducers} from "redux";

export enum ETransferFrom {
  WarehouseToStore = 0,
  StoreToWarehouse = 1
}

export interface Transfer {
  id: string;
  itemId: string;
  quantity: number;
  transferFrom: ETransferFrom;
}

const actions = createStandardActions(placeholder<Transfer>(), 'TRANSFER/SET', 'TRANSFER/SAVE');
const selectors = createStandardSelectors(placeholder<Transfer>(), s => getEntities(s).transfers);
export type TransferActions = GetActions<typeof actions>;
export const transfers = combineReducers({items: standardItemsReducer<Transfer, TransferActions>(actions)});
export const transferStore = readonly({
  selectors: {
    ...selectors
  },
  actions: {
    ...actions
  }
});
